export const cloudCounterRoutes = [
    {
        path: '/cloudCounter/home',
        name: 'cloudCounterHome',
        component: () => import('@/views/cloudCounter/home.vue'),
        meta: {
            auth: false,
            metaTitle: '雲端e櫃檯',
            hideMenu: false,
            pageTitle: '雲端e櫃檯',
        },
    },
    {
        path: '/cloudCounter/detail/loan',
        name: 'cloudCounterDetailLoan',
        component: () => import('@/views/cloudCounter/detail/loan.vue'),
        meta: {
            auth: false,
            metaTitle: '申請內容',
            hideMenu: false,
            pageTitle: '申請內容',
        },
    },
    {
        path: '/cloudCounter/detail/name',
        name: 'cloudCounterDetailName',
        component: () => import('@/views/cloudCounter/detail/name.vue'),
        meta: {
            auth: false,
            metaTitle: '申請內容',
            hideMenu: false,
            pageTitle: '申請內容',
        },
    },
    {
        path: '/cloudCounter/detail/applicant',
        name: 'cloudCounterDetailApplicant',
        component: () => import('@/views/cloudCounter/detail/applicant.vue'),
        meta: {
            auth: false,
            metaTitle: '申請內容',
            hideMenu: false,
            pageTitle: '申請內容',
        },
    },
    {
        path: '/cloudCounter/detail/beneficiary',
        name: 'cloudCounterDetailBeneficiary',
        component: () => import('@/views/cloudCounter/detail/beneficiary.vue'),
        meta: {
            auth: false,
            metaTitle: '申請內容',
            hideMenu: false,
            pageTitle: '申請內容',
        },
    },

    {
        path: '/cloudCounter/update-applicant/form',
        name: 'cloudCounterUpdateApplicantForm',
        component: () => import('@/views/cloudCounter/update-applicant/form.vue'),
        meta: {
            auth: false,
            metaTitle: '要保人變更',
            hideMenu: false,
            pageTitle: '要保人變更',
        },
    },
    {
        path: '/cloudCounter/update-applicant/check',
        name: 'cloudCounterUpdateApplicantCheck',
        component: () => import('@/views/cloudCounter/update-applicant/check.vue'),
        meta: {
            auth: false,
            metaTitle: '要保人變更',
            hideMenu: false,
            pageTitle: '要保人變更',
        },
    },
    {
        path: '/cloudCounter/reserve/phone',
        name: 'cloudCounterReservePhone',
        component: () => import('@/views/cloudCounter/reserve/phone.vue'),
        meta: {
            auth: false,
            metaTitle: '預約視訊驗證',
            hideMenu: false,
            pageTitle: '預約視訊驗證',
        },
    },
    {
        path: '/cloudCounter/reserve/time',
        name: 'cloudCounterReserveTime',
        component: () => import('@/views/cloudCounter/reserve/time.vue'),
        meta: {
            auth: false,
            metaTitle: '預約視訊驗證',
            hideMenu: false,
            pageTitle: '預約視訊驗證',
        },
    },
    {
        path: '/cloudCounter/video-operation/start',
        name: 'cloudCounterVideoOperationStart ',
        component: () => import('@/views/cloudCounter/video-operation/start.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/clause',
        name: 'cloudCounterVideoOperationClause',
        component: () => import('@/views/cloudCounter/video-operation/clause.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/login',
        name: 'cloudCounterVideoOperationLogin',
        component: () => import('@/views/cloudCounter/video-operation/login.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/reservation/loan',
        name: 'cloudCounterVideoOperationReservationLoan',
        component: () => import('@/views/cloudCounter/video-operation/reservation/loan.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/reservation/name',
        name: 'cloudCounterVideoOperationReservationName',
        component: () => import('@/views/cloudCounter/video-operation/reservation/name.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/reservation/applicant',
        name: 'cloudCounterVideoOperationReservationApplicant',
        component: () => import('@/views/cloudCounter/video-operation/reservation/applicant.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/reservation/beneficiary',
        name: 'cloudCounterVideoOperationReservationBeneficiary',
        component: () => import('@/views/cloudCounter/video-operation/reservation/beneficiary.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/verify',
        name: 'cloudCounterVideoOperationVerify',
        component: () => import('@/views/cloudCounter/video-operation/verify.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/video-operation/ocr-id',
        name: 'cloudCounterVideoOperationOcrId',
        component: () => import('@/views/cloudCounter/video-operation/ocr-id.vue'),
        meta: {
            auth: false,
            metaTitle: '視訊作業',
            hideMenu: false,
            pageTitle: '視訊作業',
        },
    },
    {
        path: '/cloudCounter/verification',
        name: 'cloudCounterVerification',
        component: () => import('@/views/cloudCounter/verification.vue'),
        meta: {
            auth: false,
            metaTitle: '行動電話驗證',
            hideMenu: false,
            pageTitle: '行動電話驗證',
        },
    },
    {
        path: '/cloudCounter/finish',
        name: 'cloudCounterFinish',
        component: () => import('@/views/cloudCounter/finish.vue'),
        meta: {
            auth: false,
            metaTitle: '委託受理完成',
            hideMenu: false,
            pageTitle: '委託受理完成',
        },
    },
    {
        path: '/cloudCounter/loan/loan-select-policy',
        name: 'cloudCounterLoanLoanSelectPolicy',
        component: () => import('@/views/cloudCounter/loan/loan-select-policy.vue'),
        meta: {
            auth: false,
            metaTitle: '保單借款',
            hideMenu: false,
            pageTitle: '保單借款',
        },
    },
    {
        path: '/cloudCounter/loan/loan-check',
        name: 'cloudCounterLoanLoanCheck',
        component: () => import('@/views/cloudCounter/loan/loan-check.vue'),
        meta: {
            auth: false,
            metaTitle: '保單借款',
            hideMenu: false,
            pageTitle: '保單借款',
        },
    },
    {
        path: '/cloudCounter/update-name/update-name-form',
        name: 'cloudCounter-update-name-update-name-form',
        component: () => import('@/views/cloudCounter/update-name/update-name-form.vue'),
        meta: {
            auth: false,
            metaTitle: '要保人或被保險人姓名變更',
            hideMenu: false,
            pageTitle: '要保人或被保險人姓名變更',
        },
    },
    {
        path: '/cloudCounter/update-name/update-name-check',
        name: 'cloudCounter-update-name-update-name-check',
        component: () => import('@/views/cloudCounter/update-name/update-name-check.vue'),
        meta: {
            auth: false,
            metaTitle: '要保人或被保險人姓名變更',
            hideMenu: false,
            pageTitle: '要保人或被保險人姓名變更',
        },
    },
    {
        path: '/cloudCounter/update-beneficiary/update-beneficiary-form',
        name: 'cloudCounter-update-beneficiary-update-beneficiary-form',
        component: () => import('@/views/cloudCounter/update-beneficiary/update-beneficiary-form.vue'),
        meta: {
            auth: false,
            metaTitle: '受益人變更',
            hideMenu: false,
            pageTitle: '受益人變更',
        },
    },
    {
        path: '/cloudCounter/update-beneficiary/update-beneficiary-check',
        name: 'cloudCounter-update-beneficiary-update-beneficiary-check',
        component: () => import('@/views/cloudCounter/update-beneficiary/update-beneficiary-check.vue'),
        meta: {
            auth: false,
            metaTitle: '受益人變更',
            hideMenu: false,
            pageTitle: '受益人變更',
        },
    },
];
